import {
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography,
} from "antd";
import React, { useState, useEffect, useMemo } from "react";
import {
  toOptions2,
  toRoomOptions,
} from "../../config";
import { medicalExaminationService } from "api";
import "./RegisterInfo.scss";
import { useAppSelector } from "redux/hooks";
import Notification from "components/common/notification/notification";

const RegisterInfo = (props) => {
  const action = useAppSelector((state) => state.receive);
  const { form } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const [examServiceCategory, setExamServiceCategory] = useState<any>([]);
  const [rooms, setRooms] = useState<any>(null);
  const fetchExamServiceCategory = async () => {
    try {
      setLoading(true);
      let response =
        await medicalExaminationService.getListExamServiceCategory();
      setExamServiceCategory(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      Notification("error", "Lỗi xảy ra khi lấy danh mục dịch vụ");
    }
  };
  const fetchRooms = async () => {
    try {
      setLoading(true);
      let response = await medicalExaminationService.getListRoomCategory();
      setRooms(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      Notification("error", "Lỗi xảy ra khi lấy danh mục phòng khám");
    }
  };
  // useMemo(() => {
  //   if (
  //     examServiceCategory?.length > 0 &&
  //     (action.actionType === RECEIVE_ACTION_TYPE.PHIEUKHAMMOI ||
  //       action.actionType === RECEIVE_ACTION_TYPE.BENHNHANMOI)
  //   ) {
  //     // form.resetFields();
  //     form.setFieldValue("dichVu", toOptions2(examServiceCategory)?.[0]?.value);
  //     // form.setFieldValue("phong", toRoomOptions(rooms)?.[0]?.value);
  //   }
  // }, [examServiceCategory, action, rooms]);
  // useMemo(() => {
  //   if (
  //     rooms?.length > 0 &&
  //     (action.actionType === RECEIVE_ACTION_TYPE.PHIEUKHAMMOI
  //       // action.actionType === RECEIVE_ACTION_TYPE.BENHNHANMOI)
  //   ) {
  //     form.setFieldValue("phong", toRoomOptions(rooms)[0].value);
  //   }
  // }, [, action]);
  useEffect(() => {
    fetchExamServiceCategory();
    fetchRooms();
  }, []);
  return (
    <Row className="register-info">
      <Row>
        <Typography.Text strong>Đăng ký khám bệnh</Typography.Text>
      </Row>
      <Divider type="horizontal" />
      <Row>
        <Form labelAlign="left" form={form}>
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Dịch vụ</Typography.Text>}
                name="dichVu"
                labelAlign="left"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                rules={[{ required: true, message: "Dịch vụ là bắt buộc" }]}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className="data-select-field"
                  placeholder="Chọn"
                  options={
                    examServiceCategory ? toOptions2(examServiceCategory) : []
                  }
                  allowClear
                  disabled={action.dataPassing?.isThanhToanCD ?? false}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Phòng</Typography.Text>}
                name="phong"
                labelAlign="left"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                rules={[{ required: true, message: "Phòng là bắt buộc" }]}
              >
                <Select
                  className="data-select-field"
                  placeholder="Chọn"
                  options={rooms ? toRoomOptions(rooms) : []}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Lý do khám</Typography.Text>}
                name="lyDoKham"
                labelAlign="left"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
              >
                <Input className="data-input-field" placeholder="Nhập" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Lý do Khác</Typography.Text>}
                name="lyDoKhac"
                labelAlign="left"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
              >
                <Input className="data-input-field" placeholder="Nhập" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Row>
    </Row>
  );
};

export default RegisterInfo;
